<template>
  <section>
      <div class="width">
       <header class="container1_1">
          
          <h1>My certificates
</h1>
      
      <img src="../../assets/underline.png" alt="">
  </header>

<div class="flex">

<div class="container1 container">
    <img src="../../assets/certficate1.png" alt="">
    <h3>CERTIFICATION REQUIREMENT <br>
FOR TEACHING CHILDREN’S YOGA</h3>
<button>View Certificate</button>
</div>
<div class="container2 container">
    <img src="../../assets/certficate1.png" alt="">
    <h3>CERTIFICATION REQUIREMENT <br>
FOR TEACHING TEEN’S YOGA</h3>
<button>View Certificate</button>
</div>
<div class="container3 container">
    <img src="../../assets/certficate1.png" alt="">
    <h3>CERTIFICATION  FOR <br>
TRAUMA-INFORMED YOGA</h3>
<button>View Certificate</button>
</div>
<div class="container4 container">
    <img src="../../assets/certficate4.png" alt="">
    <h3>LEVEL - 1 <br>
YOGA INSTRUCTOR</h3>
<button>View Certificate</button>
</div>
<div class="container5 container">
    <img src="../../assets/certficate5.png" alt="">
    <h3>CERTIFICATION REQUIREMENT <br>
FOR TRAIN THE TRAINER </h3>
<button>View Certificate</button>
</div>


</div>
</div>
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>
h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
.container1_1{
        display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;
    max-width: 1217px;
    margin: auto;
    height: 96px;
    margin-top: 130px;
}

.width{
    width: 90%;
    margin: auto;
}
.flex{
        display: flex;
    flex-wrap: wrap;
    max-width: 1217px;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    min-height: 656px;
}
.container{
display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
        height: 321px;
    text-align: center;
        width: 346px;
}
.container5{
       margin-right: 425px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 265px;
    text-align: center;
    width: 346px;
}
button{
     color: black;
    background-color: transparent;
    border: none;
    padding: 15px 30px;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid #791E94;
    transition: 0.3s ease-in;

}
button:hover{
    background-color: #791E94;
    color: white;
}
h3{
    line-height: 27px;
    font-weight: 600;
}


@media (max-width:780px){
    .flex{
            justify-content: center;
            min-height: 1913px;
    }
    .container5{
        margin-right:0px;
    }
}
</style>